export default {
  'Resize for': 'Resize untuk',
  'Add 10 videos at most': 'Tambah 10 video paling banyak.',
}